import gql from 'graphql-tag';

export const DeleteParticipant = gql`
  mutation DeleteParticipant($organizationId: ID!, $participantId: ID!) {
    deleteParticipant(organizationId: $organizationId, participantId: $participantId) {
      id
    }
  }
`;
